import unescape from 'lodash/unescape';

export const unescapeText = text => {
    return unescape(text).replace(new RegExp('&apos;', 'g'), "'");
};



// WEBPACK FOOTER //
// ./src/constants/components.js